// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"selection-items_shadow__3HyW1","selectionItem":"selection-items_selectionItem__1pUOp"};